import { render, staticRenderFns } from "./ThisWeek.vue?vue&type=template&id=a3c2e9f4&scoped=true&lang=pug&"
import script from "./ThisWeek.vue?vue&type=script&lang=js&"
export * from "./ThisWeek.vue?vue&type=script&lang=js&"
import style0 from "./ThisWeek.vue?vue&type=style&index=0&id=a3c2e9f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c2e9f4",
  null
  
)

export default component.exports